import { createContext } from "react";



const webData = {

}

// use-context
const GlobalContext = createContext(null);
const globalStates =  {
    globalContext: GlobalContext,
    webData
};

export default globalStates as any;
